import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { type PortalRole } from '@shared/services/role-context.service';
import { UsermenuComponent } from '../../usermenu/usermenu.component';

import { type ResolvedShellNavItem } from '../navigation/shell-nav.types';
import { DataService } from '@shared/services/data/data.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [NgClass, NgTemplateOutlet, RouterLink, UsermenuComponent],
})
export class SideNavComponent {
  constructor(readonly dataService: DataService) {}

  @Input() items: ResolvedShellNavItem[] = [];
  @Input() mobile = false;
  @Input() roleOptions: Array<{ label: string; value: PortalRole }> = [];
  @Input() activeRole: PortalRole | null = null;
  @Input() roleLabel = '';
  @Input() sectionLabel = '';
  @Input() brandTitle = '';
  @Input() version = '';

  roleMenuOpen = false;

  @Output() roleChange = new EventEmitter<PortalRole | null>();
  @Output() groupToggle = new EventEmitter<string>();
  @Output() navigate = new EventEmitter<void>();

  onGroupToggle(item: ResolvedShellNavItem, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.groupToggle.emit(item.id);
  }

  onGroupKeyDown(item: ResolvedShellNavItem, event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    this.onGroupToggle(item, event);
  }

  onNavigate(): void {
    this.navigate.emit();
  }

  onRoleSelectionChange(role: PortalRole | null): void {
    this.roleChange.emit(role);
  }

  toggleRoleMenu(): void {
    this.roleMenuOpen = !this.roleMenuOpen;
  }

  onRoleOptionClick(role: PortalRole, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.onRoleSelectionChange(role);
    this.roleMenuOpen = false;
  }

  isRoleActive(role: PortalRole): boolean {
    return this.activeRole === role;
  }

  getRoleIcon(role: PortalRole | null): string {
    switch (role) {
      case 'admin':
        return 'pi pi-shield';
      case 'instanceadmin':
        return 'pi pi-sitemap';
      default:
        return 'pi pi-user';
    }
  }

  getActiveRoleLabel(): string {
    return this.roleOptions.find((option) => option.value === this.activeRole)?.label ?? '';
  }

  isGroup(item: ResolvedShellNavItem): boolean {
    return !!item.items?.length;
  }
}
